import trip_pc from "../../assets/images/Introduction/trip_pc.webp";

import his_mobi from "../../assets/images/Introduction/his_mobi.webp";
import his_pc from "../../assets/images/Introduction/his_pc.webp";
export default function Trip() {
  return (
    <div
      className="w-full bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${trip_pc})`,
      }}
    >
      <div className="bg-bggra1">
        <div className="w-full container  mx-auto px-[20px] py-[50px] flex flex-col items-center gap-3 md:gap-6 justify-center">
          <div className="flex flex-col items-center justify-center gap-1">
            <p className="text-[28px] text-white font-semibold text-center">
              LỊCH SỬ HÌNH THÀNH VÀ PHÁT TRIỂN
            </p>
          </div>

          <div className="flex items-center justify-center">
            <img
              src={his_mobi}
              alt="bi"
              className="w-[65%] h-auto object-cover block md:hidden"
            />
            <img
              src={his_pc}
              alt="bn"
              className="w-[65%] h-auto object-contain hidden md:block"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
